export enum RoleType {
   Admin = 'Admin',
   SuperAdmin = 'SuperAdmin',
   User = 'User',
}
